import React from 'react';
import logoName from '../../assets/samasti-name.png';
import SamastixLogoMark from './SamastixLogoMark';

/**
 * Brand lockup aligned with samastix.com: wordmark image + logo mark.
 */
export function LogoMark({ className = 'nav-logo-mark shrink-0', light = false }) {
  return (
    <SamastixLogoMark
      variant={light ? 'dark' : 'default'}
      className={className}
    />
  );
}

export default function BrandLogo({
  subtitle,
  collapsed = false,
  className = '',
  light = false,
}) {
  if (collapsed) {
    return (
      <div className={`flex justify-center ${className}`}>
        <LogoMark className="w-8 h-8 shrink-0" light={light} />
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-1 min-w-0 ${className}`}>
      <div className="flex items-center nav-logo-lockup shrink-0 min-w-0">
        <img
          src={logoName}
          alt="Samastix"
          width={110}
          height={24}
          className={`h-5 sm:h-6 w-auto object-contain max-w-[110px] sm:max-w-none ${
            light ? 'login-nav__logo-invert' : ''
          }`}
        />
        <LogoMark light={light} />
      </div>
      {subtitle && (
        <span
          className={`text-[10px] font-semibold tracking-wider uppercase truncate block pl-0.5 ${
            light ? 'text-[#8593a8]' : 'text-slate-500'
          }`}
        >
          {subtitle}
        </span>
      )}
    </div>
  );
}
